






































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

import { ICategory } from "@/@types/menu/menu/menu";
import { ILocale } from "@/@types/locale";

@Component({
  components: {
    BSwitch,
    LanguagesButtons,
    "submit-reset-button-groop": SubmitResetButtonGroop,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
export default class ChangeCategoryForm extends Vue {
  @Prop({ type: Object, default: null }) category!: ICategory;
  @Prop({ type: String, default: "" }) activeBar!: string;

  locale = this.$store.getters.getLanguages[0];
  show = true;

  name = "";
  names: ILocale = {};
  showCategory = false;

  get cat(): ICategory {
    return {
      _id: this.category ? this.category._id : "",
      show: this.showCategory,
      name: this.names,
      shop_id: this.activeBar,
    };
  }

  changeShowCategory(toggle: boolean): void {
    this.showCategory = toggle;
  }

  @Watch("locale")
  getActiveName(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  @Watch("name")
  addActiveName(): void {
    this.names[this.locale] = this.name;
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    const id = this.category ? this.category._id : "";
    this.$emit("updateCategory", id, this.cat);
    this.onReset();
  }

  onReset(): void {
    this.name = "";
    this.showCategory = false;
    this.names = {};

    this.show = false;
    this.$nextTick(() => {
      this.show = true;
    });
  }

  @Watch("category")
  changeCategory(): void {
    if (this.category) {
      this.names = this.category.name;
      this.getActiveName();
      this.showCategory = this.category.show;
    }
  }

  mounted(): void {
    this.changeCategory();
  }

  destroyed(): void {
    this.name = "";
    this.names = {};
    this.showCategory = false;
  }
}
